// extracted by mini-css-extract-plugin
export default {"container":"Comment_container__A6gbS","message":"Comment_message__FrntR","user":"Comment_user__+773z"};